var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"map"}},[_c('map-action-buttons',{staticClass:"map-buttons"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }